import { User } from '../types';

export const getStoredUser = (): User | null => {
  try {
    const userStr = localStorage.getItem('adminUser');
    return userStr ? JSON.parse(userStr) : null;
  } catch {
    return null;
  }
};

export const storeUser = (user: User): void => {
  localStorage.setItem('adminUser', JSON.stringify(user));
};

export const getStoredToken = (): string | null => {
  return localStorage.getItem('adminToken');
};

export const storeToken = (token: string): void => {
  localStorage.setItem('adminToken', token);
};

export const clearAuth = (): void => {
  localStorage.removeItem('adminUser');
  localStorage.removeItem('adminToken');
};

export const isAuthenticated = (): boolean => {
  const token = getStoredToken();
  const user = getStoredUser();
  return !!(token && user && user.isAdmin);
};
